import { useId } from "react";
import { Tooltip } from "react-tooltip";

type FailureReasonProps = {
  failure_reason: string;
};

const PrinterTaskFailureReason = ({ failure_reason }: FailureReasonProps) => {
  const uniqueId = useId();
  const fullText = failure_reason || '';
  const shortText = fullText.length > 60 ? `${fullText.slice(0, 60)}...` : fullText;

  return (
    <>
      <p
        data-tooltip-id={uniqueId}
        data-tooltip-place="top"
        data-tooltip-html={fullText}
        className="max-w-[400px] truncate text-white-900 text-sm cursor-default"
      >
        {shortText}
      </p>

      <Tooltip
        id={uniqueId}
        className="z-50 max-w-[500px] whitespace-pre-wrap break-words bg-[#1f1f1f] p-4 border border-gray-700 text-white-900 text-sm"
      />
    </>
  );
};

export default PrinterTaskFailureReason;